import { AgFinancing, AgFinancingPhase4Status, AgStateName } from '@indigo-ag/schema';
import i18next from 'core/i18n';

import { Phase2Util, Phase3Util, Phase4Util } from './phases';

export class FinancingProcessUtil {
  static phase2 = Phase2Util;
  static phase3 = Phase3Util;
  static phase4 = Phase4Util;

  /**
   * Get the current phase given a financing process
   * @param fProcess the financing process itself
   * @returns The enum AgStateName of the current phase that the process is
   */
  static getCurrentPhase(fProcess: AgFinancing): AgStateName {
    return fProcess.currentStates?.includes(AgStateName.PHASE_4) ||
      fProcess.currentStates?.includes(AgStateName.AWAITING_CONTRACT_VALIDATION)
      ? AgStateName.PHASE_4
      : fProcess.currentStates?.includes(AgStateName.PHASE_3)
      ? AgStateName.PHASE_3
      : fProcess.currentStates?.includes(AgStateName.PHASE_2) ||
        fProcess.currentStates?.includes(AgStateName.P2_PENDING_ACTIVATION)
      ? AgStateName.PHASE_2
      : fProcess.currentStates?.includes(AgStateName.PHASE_1)
      ? AgStateName.PHASE_1
      : fProcess.currentStates?.includes(AgStateName.ON_HOLD)
      ? AgStateName.ON_HOLD
      : AgStateName.CLOSED;
  }

  /**
   * Get the current stage for a financing process
   * @param fProcess The financing process itself
   */
  static getCurrentStage(fProcess: AgFinancing): string {
    let stage: string = ' - ';
    const currentPhase = FinancingProcessUtil.getCurrentPhase(fProcess);

    switch (currentPhase) {
      case AgStateName.PHASE_1:
        stage = i18next.t('backgroundCheck_title');
        break;

      case AgStateName.PHASE_2:
        stage = i18next.t('collateralAndCreditAnalysis');
        break;

      case AgStateName.PHASE_3:
        stage = i18next.t('documentRegistration');
        break;

      case AgStateName.PHASE_4:
        stage = i18next.t('fundAssignment');
        break;

      case AgStateName.ON_HOLD:
        stage = i18next.t('onHold');
        break;

      case AgStateName.CLOSED:
        stage = i18next.t('completed', { context: 'female' });
        break;
    }

    // fallback.
    if (fProcess.completedAt) {
      stage = i18next.t('completed', { context: 'female' });
    }

    return stage;
  }

  /**
   * Know if a process is ready add to the current cession
   * @param fProcess The financing process itself
   * @returns boolean that confirms that the negotiation is ready to be added to the current cession group
   */
  static readyToAddToCurrentCession(fProcess: AgFinancing): boolean {
    return fProcess.phase4?.status === AgFinancingPhase4Status.AWAITING_ASSIGNMENT && !fProcess.agGroup;
  }
}
